import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instancep7dfbo63nk35 as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$default385fuvmpsl23h as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instance13tvuha6xx6us as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().z4e("Buffer doesn't contain required number of bytes (size: " + $this.v2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.t4e_1 = null;
        this.u4e_1 = null;
        this.v4e_1 = 0n;
      }
      v2() {
        return this.v4e_1;
      }
      a3y() {
        return this;
      }
      b3y() {
        return this.v2() === 0n;
      }
      c3y(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.v2() < byteCount) {
          throw EOFException().z4e("Buffer doesn't contain required number of bytes (size: " + this.v2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      h3y(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().s2(toString(message));
        }
        return this.v2() >= byteCount;
      }
      k3y() {
        var tmp0_elvis_lhs = this.t4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.v2();
        if (segmentSize === 0) {
          this.h4f();
          return this.k3y();
        }
        var v = segment.i4f();
        this.v4e_1 = subtract(this.v4e_1, 1n);
        if (segmentSize === 1) {
          this.h4f();
        }
        return v;
      }
      j4f() {
        var tmp0_elvis_lhs = this.t4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.v2();
        if (segmentSize < 2) {
          this.c3y(2n);
          if (segmentSize === 0) {
            this.h4f();
            return this.j4f();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.k3y() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.k3y() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.k4f();
        this.v4e_1 = subtract(this.v4e_1, 2n);
        if (segmentSize === 2) {
          this.h4f();
        }
        return v;
      }
      l4f() {
        return Unit_instance;
      }
      m4f(out, startIndex, endIndex) {
        checkBounds(this.v2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.v4e_1 = add(out.v4e_1, remainingByteCount);
        var s = this.t4e_1;
        while (currentOffset >= fromInt(ensureNotNull(s).c4f_1 - s.b4f_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.c4f_1 - s.b4f_1 | 0));
          s = s.f4f_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).n4f();
          copy.b4f_1 = copy.b4f_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.b4f_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.c4f_1;
          tmp.c4f_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.t4e_1 == null) {
            out.t4e_1 = copy;
            out.u4e_1 = copy;
          } else if (false) {
            out.u4e_1 = ensureNotNull(out.u4e_1).o4f(copy).p4f();
            if (ensureNotNull(out.u4e_1).g4f_1 == null) {
              out.t4e_1 = out.u4e_1;
            }
          } else {
            out.u4e_1 = ensureNotNull(out.u4e_1).o4f(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.c4f_1 - copy.b4f_1 | 0));
          currentOffset = 0n;
          s = s.f4f_1;
        }
      }
      q4f() {
        var result = this.v2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.u4e_1);
        if (tail.c4f_1 < 8192 && tail.e4f_1) {
          result = subtract(result, fromInt(tail.c4f_1 - tail.b4f_1 | 0));
        }
        return result;
      }
      x3w(position) {
        if (position < 0n || position >= this.v2()) {
          throw IndexOutOfBoundsException().n3('position (' + position.toString() + ') is not within the range [0..size(' + this.v2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.t4e_1).r4f(0);
        }
        // Inline function 'kotlinx.io.seek' call
        if (this.t4e_1 == null) {
          return ensureNotNull(null).r4f(convertToInt(subtract(position, -1n)));
        }
        if (subtract(this.v2(), position) < position) {
          var s = this.u4e_1;
          var offset = this.v2();
          $l$loop: while (!(s == null) && offset > position) {
            offset = subtract(offset, fromInt(s.c4f_1 - s.b4f_1 | 0));
            if (offset <= position)
              break $l$loop;
            s = s.g4f_1;
          }
          var tmp0 = s;
          var offset_0 = offset;
          return ensureNotNull(tmp0).r4f(convertToInt(subtract(position, offset_0)));
        } else {
          var s_0 = this.t4e_1;
          var offset_1 = 0n;
          $l$loop_0: while (!(s_0 == null)) {
            var tmp0_0 = offset_1;
            // Inline function 'kotlin.Long.plus' call
            var other = s_0.c4f_1 - s_0.b4f_1 | 0;
            var nextOffset = add(tmp0_0, fromInt(other));
            if (nextOffset > position)
              break $l$loop_0;
            s_0 = s_0.f4f_1;
            offset_1 = nextOffset;
          }
          var tmp0_1 = s_0;
          var offset_2 = offset_1;
          return ensureNotNull(tmp0_1).r4f(convertToInt(subtract(position, offset_2)));
        }
      }
      f5() {
        return this.l3v(this.v2());
      }
      l3v(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().s2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.t4e_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().z4e('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.c4f_1 - head.b4f_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$4 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$4);
          this.v4e_1 = subtract(this.v4e_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.b4f_1 = head.b4f_1 + toSkip | 0;
          if (head.b4f_1 === head.c4f_1) {
            this.h4f();
          }
        }
      }
      s4f(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.t4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.v2();
        var toCopy = Math.min(tmp0, b);
        s.t4f(sink, startIndex, startIndex + toCopy | 0);
        this.v4e_1 = subtract(this.v4e_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.h4f();
        }
        return toCopy;
      }
      u4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.v2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.v2() ? this.v2() : byteCount;
        sink.v4f(this, bytesWritten);
        return bytesWritten;
      }
      w4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.v2() < byteCount) {
          sink.v4f(this, this.v2());
          throw EOFException().z4e('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.v2().toString() + ' bytes were written.');
        }
        sink.v4f(this, byteCount);
      }
      x4f(sink) {
        var byteCount = this.v2();
        if (byteCount > 0n) {
          sink.v4f(this, byteCount);
        }
        return byteCount;
      }
      f40() {
        return buffered(new (PeekSource())(this));
      }
      y4f(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.u4e_1 == null) {
          var result = SegmentPool_instance.o3w();
          this.t4e_1 = result;
          this.u4e_1 = result;
          return result;
        }
        var t = ensureNotNull(this.u4e_1);
        if ((t.c4f_1 + minimumCapacity | 0) > 8192 || !t.e4f_1) {
          var newTail = t.o4f(SegmentPool_instance.o3w());
          this.u4e_1 = newTail;
          return newTail;
        }
        return t;
      }
      b4g(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.y4f(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.c4g();
          var toCopy = Math.min(tmp0, b);
          tail.d4g(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.v4e_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.v4e_1 = add(tmp0_0, fromInt(other));
      }
      v4f(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().s2(toString(message));
        }
        checkOffsetAndCount(source.v4e_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.t4e_1).v2())) {
            var tail = this.u4e_1;
            var tmp;
            if (!(tail == null) && tail.e4f_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.c4f_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.f4g() ? 0 : tail.b4f_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.t4e_1).h4g(tail, convertToInt(remainingByteCount));
              source.v4e_1 = subtract(source.v4e_1, remainingByteCount);
              this.v4e_1 = add(this.v4e_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.t4e_1 = ensureNotNull(source.t4e_1).g4g(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.t4e_1);
          var movedByteCount = fromInt(segmentToMove.v2());
          source.t4e_1 = segmentToMove.i4g();
          if (source.t4e_1 == null) {
            source.u4e_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.t4e_1 == null) {
            this.t4e_1 = segmentToMove;
            this.u4e_1 = segmentToMove;
          } else if (true) {
            this.u4e_1 = ensureNotNull(this.u4e_1).o4f(segmentToMove).p4f();
            if (ensureNotNull(this.u4e_1).g4f_1 == null) {
              this.t4e_1 = this.u4e_1;
            }
          } else {
            this.u4e_1 = ensureNotNull(this.u4e_1).o4f(segmentToMove);
          }
          source.v4e_1 = subtract(source.v4e_1, movedByteCount);
          this.v4e_1 = add(this.v4e_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      j4g(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.u4f(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      k4g(byte) {
        this.y4f(1).l4g(byte);
        this.v4e_1 = add(this.v4e_1, 1n);
      }
      m4g(short) {
        this.y4f(2).n4g(short);
        this.v4e_1 = add(this.v4e_1, 2n);
      }
      q6() {
        return Unit_instance;
      }
      toString() {
        if (this.v2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.v2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$1 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$1);
        var builder = StringBuilder().yb(imul(len, 2) + (this.v2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.t4e_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.v2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.o4g(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$2 = b_0 >> 4;
            var tmp_0 = builder.t1(tmp[tmp$ret$2 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$3 = b_0 & 15;
            tmp_0.t1(tmp_1[tmp$ret$3]);
          }
          curr = curr.f4f_1;
        }
        if (this.v2() > fromInt(maxPrintableBytes)) {
          builder.t1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.v2().toString() + ' hex=' + builder.toString() + ')';
      }
      h4f() {
        var oldHead = ensureNotNull(this.t4e_1);
        var nextHead = oldHead.f4f_1;
        this.t4e_1 = nextHead;
        if (nextHead == null) {
          this.u4e_1 = null;
        } else {
          nextHead.g4f_1 = null;
        }
        oldHead.f4f_1 = null;
        SegmentPool_instance.p4g(oldHead);
      }
      q4g() {
        var oldTail = ensureNotNull(this.u4e_1);
        var newTail = oldTail.g4f_1;
        this.u4e_1 = newTail;
        if (newTail == null) {
          this.t4e_1 = null;
        } else {
          newTail.f4f_1 = null;
        }
        oldTail.g4f_1 = null;
        SegmentPool_instance.p4g(oldTail);
      }
    }
    protoOf($).e4g = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
